import { makeStyles, shorthands } from '@fluentui/react-components';
import { tokens } from '@bingads-webui-fluent-component/tokens';

export const useTypeStyles = makeStyles({
  page: {
    ...shorthands.paddingBlock(tokens.adsui_spacingXXXL),
    ...shorthands.paddingInline(tokens.adsui_spacingXXXL),
  },
  'page-centered': {
    ...shorthands.paddingBlock(tokens.adsui_spacingXXXL),
    ...shorthands.paddingInline(tokens.adsui_spacingXXXL),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  table: {
    ...shorthands.borderRadius(tokens.adsui_radiusLarge),
  },
  'main-form': {
    ...shorthands.paddingBlock(tokens.adsui_spacingL),
    ...shorthands.paddingInline(tokens.adsui_spacingL),
    ...shorthands.borderRadius(tokens.adsui_radiusLarge),
  },
  'main-dashboard': {
    ...shorthands.paddingBlock(tokens.adsui_spacingL),
    ...shorthands.paddingInline(tokens.adsui_spacingL),
    ...shorthands.borderRadius(tokens.adsui_radiusXLarge),
  },
  'support-main': {
    ...shorthands.paddingBlock(tokens.adsui_spacingL),
    ...shorthands.paddingInline(tokens.adsui_spacingL),
    ...shorthands.borderRadius(tokens.adsui_radiusSmall),
  },
  'image-banner': {
    ...shorthands.borderRadius(tokens.adsui_radiusLarge),
    ...shorthands.paddingBlock(tokens.adsui_spacingXXXL),
    ...shorthands.paddingInline(tokens.adsui_spacingXXXL),
  },
});
